import {useDevice} from 'platform/foundation-tw';

export function useIsMobileView(): boolean {
  const device = useDevice();
  return device === 'mobile';
}
